import { envId, isDevelopment } from "./utils";

export {
  CART_ID_COOKIE, OTO_ORDERS_COOKIE,
  OTO_TOKEN_COOKIE, SESSION_ID_COOKIE
} from 'shared-react-components';

export const cookieDomain = (baseUrl?: string) => {
  const hostname = baseUrl ? new URL(baseUrl).hostname.replace('www.', '') : 'localhost';
  const domain = hostname !== 'localhost' ? `.${hostname}` : undefined;
  return domain;
}

export const cookieSameSite = (baseUrl?: string, secure?: boolean) => {
  if (secure) {
    if (isDevelopment(baseUrl)) {
      return 'none';
    }
    const env = envId(baseUrl);
    if (env === 'sb' || env === 'qa') {
      return 'none';
    }
  }

  return 'lax';
}

export const cookieSecure = (baseUrl?: string) => {
  return baseUrl?.startsWith("https://");
}